import { Component, Inject, Input, EventEmitter, Output, ViewChild } from '@angular/core';

import { Subject } from 'rxjs';

import { MultiFilterableSelectComponent } from '../../../../shared/filterable-select/components/multi-filterable-select.component';

import { SousParcService } from '../../sous-parc/services/sous-parc.service';
import { SousParcTLR } from '../../sous-parc/entities/sous-parc-tlr.entity';

import { OuvrageService } from '../services/ouvrage.service';
import { OuvrageTLR } from '../entities/ouvrage-tlr.entity';

import { ParcTLR } from '../../parc/entities/parc-tlr.entity';

@Component({
	selector: 'ouvrage-by-sous-parc-multi-selector',
	templateUrl: 'ouvrage-by-sous-parc-multi-selector.html',
})
export class OuvrageBySousParcMultiSelectorComponent {
	idClasseOnd!: number;
	
	sousParcs: SousParcTLR[] = [];
	ouvrages: OuvrageTLR[] = [];

	getSousParcLabel = (sousParc: SousParcTLR) => '...dans ' + sousParc.description + ' (' + sousParc.code + ')';
	checkCategory = (ouvrage: OuvrageTLR, sousParc: SousParcTLR) => ouvrage.sousParcId === sousParc.id;
	isOuvragePreselected = (ouvrage: OuvrageTLR) => this._selectedOuvrageIds.includes(ouvrage.id);
	
	reinitSubject = new Subject<void>();

	constructor( //
		@Inject(SousParcService) private sousParcService: SousParcService, //
		@Inject(OuvrageService) private ouvrageService: OuvrageService //
	) {
		this.ouvrageService.getClasseOuvrageList().subscribe(
			(classes) => {
				let idClasseOnd = classes.filter($ => $.code === 'OND')[0].id;
				this.idClasseOnd = idClasseOnd;
			}
		)
	}

	@ViewChild(MultiFilterableSelectComponent) input!: MultiFilterableSelectComponent;

	@Input() id!: string;
	@Input() disabled = false;
	@Input() maxNumberOfSelections: number | null = null;
	
	@Input() label: string = 'Ouvrage(s)';
	
	// Classes pour l'affichege
	public _labelClass: string = 'col-md-1';
	@Input() set labelClass(value: string | undefined) {
		if (value) {
			this._labelClass = value;
		}	
	}
	get labelClass(): string | undefined {
		return this._labelClass;
	}
	
	public _fieldClass: string = 'col-md-7';
	@Input() set fieldClass(value: string | undefined) {
		if (value) {
			this._fieldClass = value;
		}
	}
	get fieldClass(): string | undefined {
		return this._fieldClass;
	}
	
	// Par defaut, pour les parcs solaires decentralise, on ignore les ouvrages de la classe ouvrage "onduleur" (OND)
	private _ouvrageFilterFunction : (parc: ParcTLR, ouvrage: OuvrageTLR) => boolean = (parc, ouvrage) => parc.energie != 'Solaire' || !parc.typeOnduleur || ouvrage.classeOuvrage !== this.idClasseOnd;
	@Input() set ouvrageFilter(ouvrageFilterFunction: (parc: ParcTLR, ouvrage: OuvrageTLR) => boolean) {
		this._ouvrageFilterFunction = ouvrageFilterFunction;
	}

	public getOuvrageLabel = (ouvrage: OuvrageTLR | null | undefined) => {
		if (ouvrage) {
			return ouvrage.nom + (ouvrage.description ? ' (' + ouvrage.description + ')' : '');
		}
		return '';
	};
	@Input() set ouvrageLabelGetter(labelGetterFunction: (ouvrage: OuvrageTLR) => string) {
		this.getOuvrageLabel = (ouvrage: OuvrageTLR | null | undefined) => {
	  		if (ouvrage) {
 				return labelGetterFunction(ouvrage);
			}
			return '';
		};
	} 

	private _parc!: ParcTLR | undefined;
	@Input() set parc(parc: ParcTLR | undefined) {
		if (parc == null) {
			this.ouvrages = [];
		}
		if (parc && this._parc != parc) {
			this._parc = parc;

			// Chargement des sous-parcs			
			this.sousParcService.getSousParcTLRByParc(parc.id).subscribe(
				(sousParcs: SousParcTLR[]) => this.sousParcs = sousParcs
			);
			
			// Chargement des ouvrages
			this.ouvrageService.getOuvrageTLRByParc(parc.id).subscribe(
				(ouvrages: OuvrageTLR[]) => {
					this.ouvrages = ouvrages
						.filter($ => this._ouvrageFilterFunction(parc, $))
						.sort((o1, o2) => o1.nom.localeCompare(o2.nom))
					;
				}
			);
		}
	}
	
	private _selectedOuvrageIds: number[] = [];
	@Input() set selectedOuvrageIds(ids: number[] | undefined) {
		if (ids != undefined) {
			this._selectedOuvrageIds = ids;
			this.reinitSubject.next();
		}
	}
	get selectedOuvrageIds(): number[] | undefined {
		return this._selectedOuvrageIds;
	}
	
	@Output() selectedOuvrageIdsChange = new EventEmitter<number[]>();
	
	@Output() selectedOuvragesChange = new EventEmitter<OuvrageTLR[]>();
	
	onSelectedOuvragesChange(ouvrages: OuvrageTLR[]) {
		let ids = ouvrages.map((ouvrage: OuvrageTLR) => ouvrage.id);
		this._selectedOuvrageIds = ids;
		this.selectedOuvrageIdsChange.emit(ids);
		this.selectedOuvragesChange.emit(ouvrages);
	}
}